import api from "../../shared/services/api";
import endPoints from "../../shared/services/endPoints";
import { setUserProfile } from "../slices/userSlice";

const getProfileAction = () => async (dispatch) => {
    const res = await api("get", endPoints.PROFILE);
    if (res.success && res.data) {
        dispatch(setUserProfile(res.data));
    }
};

export { getProfileAction };
